<script lang="ts">
	import PostLink from '$lib/components/Post/Tile/PostLink.svelte';
	import { stripTags } from '$lib/utils/strings';
	import { getPostContextStore } from '$lib/components/Post/postContextStore';
	const post = getPostContextStore();
	export let target: string;
</script>

<PostLink {target}>
	<div class="summary-container px-abstract-content">
		{#if $post.title}
			<div class="title px-title">
				{$post.title}
			</div>
		{/if}

		<div class="description-container {!$post.title ? 'noTitle-font-size' : 'title-font-size'}">
			<p>
				{stripTags(['.*?'], $post.description).trim()}
			</p>
		</div>

		<div class="byline-container px-byline">
			{#if $post.source.network}
				<span>{$post.source.network}</span>
			{/if}
			{#if $post.author.name}
				<span> - </span>
				<span> {$post.author.name}</span>
			{/if}
		</div>
	</div>
</PostLink>

<style>
	.summary-container {
		padding-inline: var(--gutterDefault);
		overflow: hidden;
	}

	.title {
		max-block-size: 180px;
		padding-block: 7px 2px;
		overflow: hidden;
		color: var(--hubHeadlineFontColor);
		font-size: 20px;
		font-weight: 500;
		overflow-wrap: anywhere;
	}

	.description-container {
		padding-block: 5px 4px;
		overflow: hidden;
		color: var(--hubBodyFontColor);
		font: var(--hubBodyFont);
	}

	.description-container p {
		max-block-size: 72px;
		inline-size: 100%;
		margin: 0;
		overflow: hidden;
		font-size: 12px !important;
		font-weight: 400;
		line-height: 1.8rem;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow-wrap: anywhere;
	}

	.title-font-size {
		font-size: var(--fontSizeSmaller);
	}

	.noTitle-font-size {
		font-size: var(--fontSizeSmall);
	}

	.byline-container {
		padding-block: 5px 4px;
		padding-inline: 0;
		overflow: hidden;
		color: var(--hubDetailFontColor);
		font: var(--hubDetailFont);
		font-size: 13px !important;
		line-height: 1.8rem;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
